const ATTRIBUTE_TAXABLE_FOOD = "Taxable_Food";
const ATTRIBUTE_BRAND = "Brand";
const ATTRIBUTE_DELIVERY_TYPE = "Delivery Type";
const ATTRIBUTE_BUNDLE = "Bundle";
const ATTRIBUTE_SWATCH_IMAGE_KEY = "swatchImage";
const ATTRIBUTE_HIDE_PRICE_RANGE_KEY = "Hide_Price_Range";
const ATTRIBUTE_WAREHOUSE_PICK_UP_VALUE = "warehouse pick-up";
const ATTRIBUTE_1_VALUE = "1";
const REPLACEMENT_TYPE = "REPLACEMENT";
const PRODUCT_CLASS_TYPE_TOBACCO = "Tobacco";
const AS400_CAT_CODE_EBB = "EBB";
const AS400_DEPT_NAME_11 = "11";
export {
  AS400_CAT_CODE_EBB,
  AS400_DEPT_NAME_11,
  ATTRIBUTE_1_VALUE,
  ATTRIBUTE_BRAND,
  ATTRIBUTE_BUNDLE,
  ATTRIBUTE_DELIVERY_TYPE,
  ATTRIBUTE_HIDE_PRICE_RANGE_KEY,
  ATTRIBUTE_SWATCH_IMAGE_KEY,
  ATTRIBUTE_TAXABLE_FOOD,
  ATTRIBUTE_WAREHOUSE_PICK_UP_VALUE,
  PRODUCT_CLASS_TYPE_TOBACCO,
  REPLACEMENT_TYPE
};
